// Module
var code = " <div *ngIf=\"dnd\" class=\"dnd-pointer\"> <mat-icon class=\"handle\" svgIcon=\"gh:dnd-pointer\"></mat-icon> </div> <ng-content></ng-content>";
// Exports
module.exports = code;